import { blue } from './colours';

/**
 * One keyboard focus indicator for the whole marketing surface, so a ring never
 * varies between two controls that sit side by side. Pick the variant from the
 * surface behind the control, not from the component.
 *
 * The values match `.bl-landing-cta:focus-visible` in `globals.css`, which
 * styles the CTAs that are plain anchors rather than MUI components.
 */
export const focusRingOnDark = {
  outline: `2px solid ${blue[300]}`,
  outlineOffset: '3px',
} as const;

export const focusRingOnLight = {
  outline: `2px solid ${blue[700]}`,
  outlineOffset: '3px',
} as const;
